// src/components/QueryInput/QueryControls.js
import React from 'react';
import { Box, TextField, IconButton, CircularProgress, FormControl, Select, MenuItem, Typography, Checkbox } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const QueryControls = ({
  query,
  setQuery,
  handleQuery,
  files,
  selectedFile,
  selectedFiles,
  handleFileSelection,
  loading,
  shake
}) => {
  return (
    <>
    {files.length > 0 && (
      <FormControl fullWidth sx={{ marginBottom: '10px' }}>
        <Select
          multiple
          value={selectedFiles.includes(selectedFile) ? selectedFiles : [selectedFile, ...selectedFiles]}
          onChange={handleFileSelection}
          renderValue={(selected) => (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: '95%',
              }}
            >
                <>
                  <Typography sx={{ fontWeight: 'bold', marginRight: '8px', color: 'white' }}>
                    Context:
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      overflowX: 'auto',
                      whiteSpace: 'nowrap',
                      '&::-webkit-scrollbar': {
                        display: 'none',
                      },
                    }}
                  >
                    {selected.join(', ')}
                  </Box>
                </>
            </Box>
          )}
          sx={{
            backgroundColor: 'transparent',
            color: 'white',
            border: 'none',
            boxShadow: 'none',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiSelect-select': {
              padding: '6px',
              borderBottom: 'none',
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: '#333',
                color: 'white',
                boxShadow: 'none',
              },
            },
          }}
          disabled={files.length === 0}
        >
          <MenuItem
            key={selectedFile}
            value={selectedFile}
            disabled
            sx={{
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            <Checkbox
              checked
              sx={{
                color: 'cyan',
                '&.Mui-checked': {
                  color: 'white',
                },
              }}
            />
            {selectedFile}
          </MenuItem>
          {files
            .filter(file => file.name !== selectedFile)
            .map((file) => (
              <MenuItem
                key={file.name}
                value={file.name}
                sx={{
                  backgroundColor: 'transparent',
                  color: 'white',
                  '&.Mui-selected': {
                    backgroundColor: 'transparent !important',
                  },
                  '&:hover': {
                    backgroundColor: '#444',
                  },
                }}
              >
                <Checkbox
                  checked={selectedFiles.indexOf(file.name) > -1}
                  sx={{
                    color: 'white',
                    '&.Mui-checked': {
                      color: 'white',
                    },
                  }}
                />
                {file.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      )}
      <Box className="queryInputBox">
        <TextField
          label="Enter your message"
          fullWidth
          multiline
          minRows={1}
          maxRows={10}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleQuery();
            }
          }}
          className={`queryInputTextField ${shake ? 'shake' : ''}`}
          sx={{
            '& .MuiInputBase-input': { color: 'white' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'white',
                borderRadius: '16px',
              },
              '&:hover fieldset': {
                borderColor: 'cyan',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'cyan',
              },
            },
            '& .MuiInputLabel-root': {
              color: 'rgba(255, 255, 255, 0.7)',
              '&.Mui-focused': {
                color: 'cyan',
              },
            },
          }}
        />
        {loading ? (
          <CircularProgress
            sx={{
              color: 'white',
              margin: '10px',
            }}
          />
        ) : (
          <IconButton
            onClick={handleQuery}
            disabled={loading}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              '&:hover': {
                backgroundColor: 'white',
              },
              borderRadius: '50%',
              padding: '10px',
              margin: '10px',
            }}
          >
            <ArrowUpwardIcon sx={{ color: 'black', fontSize: 'large' }} />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default QueryControls;
